export const languages = ['ru', 'en', 'ge'];
